/* 開發用 */
export const DEVELOP_ICON_ROUTER   = `/site/develop/icon/`;
export const DEVELOP_TEST_ROUTER   = `/site/develop/test/`;
export const DEVELOP_GRADES_ROUTER = `/site/develop/grades/`;


/*
    新增頁面 ADD
    /XXX/XXX/add
    編輯頁面 EDIT
    /XXX/XXX/edit/(:id)
    唯獨模式 READ ONLY
    /XXX/XXX/read-only/(:id)
*/

/* 登陸與ROOT */
export const ENTRANCE_ROOT_ROUTER = `site`;
export const LOGIN_ROOT_ROUTER    = `/login/`;
export const HQ_ROOT_ROUTER       = `/site`;

/* 點數管理 */
// 點數總覽
export const POINTS_OVERVIEW_ROUTER = `/site/points/overview/`;
// 贈品兌換總覽
export const POINTS_REDEEM_OVERVIEW_ROUTER = `/site/points-redeem/overview/`;
// 點數活動總覽
export const POINTS_ACTIVITY_OVERVIEW_ROUTER = `/site/points/activity/overview/`;
  // 點數審核管理
export const POINTS_AUDIT_OVERVIEW_ROUTER            = `/site/points/audit/overview/`;
export const POINTS_AUDIT_OVERVIEW_TYPE_ROUTER       = `/site/points/audit/overview/:trailType(pass-trial|on-trial|non-trial)/`;
export const POINTS_AUDIT_OVERVIEW_PASS_TRIAL_ROUTER = `/site/points/audit/overview/pass-trial/`;
export const POINTS_AUDIT_OVERVIEW_ON_TRIAL_ROUTER   = `/site/points/audit/overview/on-trial/`;
export const POINTS_AUDIT_OVERVIEW_NON_TRIAL_ROUTER  = `/site/points/audit/overview/non-trial/`;
  // 贈品總覽
export const POINTS_PRODUCT_GIFT_OVERVIEW_ROUTER = `/site/points/product-gift/overview/`;

  // 行銷管理
export const PROMOTION_PLAN_OVERVIEW_ROUTER    = `/site/promotion-plan/overview/`;
export const CUSTOMER_RESOURCE_OVERVIEW_ROUTER = `/site/customer-resource/overview/`;
export const SMART_FITNESS_BAND_PROMOTION_PLAN_OVERVIEW_ROUTER = `/site/smart-fitness-band-promotion-plan/overview/`;

  // 循環訂單管理
export const CYCLE_PURCHASE_VERIFICATION_BILLING_OVERVIEW_ROUTER = '/site/cycle-purchase-verification-billing/overview/';
export const CYCLE_PURCHASE_BILLING_ROUTER                       = '/site/cycle-purchase-verification-billing/:maskID/';
export const CYCLE_PURCHASE_BILLING_ROUTER_URL                   = (maskID) => `/site/cycle-purchase-verification-billing/${maskID}/`;

  // 循環訂單總覽
export const CYCLE_PURCHASE_OVERVIEW_ROUTER           = `/site/cycle-purchase/overview/`;
export const CYCLE_PURCHASE_DETAIL_ROUTER             = `/site/cycle-purchase/detail/`;
export const CYCLE_PURCHASE_DETAIL_ROUTER_URL         = (cycleOrderID) => `/site/cycle-purchase/detail/${cycleOrderID}/`;
export const CYCLE_PURCHASE_DETAIL_TAB_ROUTER         = `/site/cycle-purchase/detail/:cycleOrderID/:tab?`;
export const CYCLE_PURCHASE_DETAIL_MAIN_ROUTER_URL    = (cycleOrderID) => `/site/cycle-purchase/detail/${cycleOrderID}/main`;
export const CYCLE_PURCHASE_DETAIL_HISTORY_ROUTER_URL = (cycleOrderID) => `/site/cycle-purchase/detail/${cycleOrderID}/history`;
export const CYCLE_PURCHASE_DETAIL_FUTURE_ROUTER_URL   = (cycleOrderID) => `/site/cycle-purchase/detail/${cycleOrderID}/future`;
export const CYCLE_PURCHASE_DETAIL_PAYMENT_ROUTER_URL  = (cycleOrderID) => `/site/cycle-purchase/detail/${cycleOrderID}/payment`;

// 循環訂單退訂總覽
export const CYCLE_PURCHASE_CANCEL_OVERVIEW_ROUTER = `/site/cycle-purchase-payment-errors/overview/`;

// 店鋪管理
export const CLUB_MANAGEMENT_MEMBER_MEMBERSHIP_ROUTER = '/site/club-management/membership/';
export const CLUB_MANAGEMENT_MEMBERSHIP_ROUTER        = '/site/club-management/membership/:membershipID/';
export const CLUB_MANAGEMENT_MEMBERSHIP_ROUTER_URL    = (membershipID) => `/site/club-management/membership/${membershipID}/`;
export const CLUB_INVENTORY_SHOP_STOCK_OVERVIEW_ROUTER = '/site/club-inventory/shop-stock/overview/';
export const CLUB_INVENTORY_SHOP_STOCK_DETAIL_ROUTER = '/site/club-inventory/shop-stock/detail/:productID/:variantID/';
export const CLUB_INVENTORY_SHOP_STOCK_DETAIL_ROUTER_URL = (productID, variantID, clubID) =>
    `/site/club-inventory/shop-stock/detail/${productID}/${variantID}/${clubID ? `?clubID=${clubID}` : ''}`;
export const CLUB_INVENTORY_PRODUCT_STOCK_OVERVIEW_ROUTER = '/site/club-inventory/product-stock/overview/';
export const CLUB_INVENTORY_PRODUCT_STOCK_DETAIL_ROUTER = '/site/club-inventory/product-stock/detail/:productID/:variantID/';
export const CLUB_INVENTORY_PRODUCT_STOCK_DETAIL_ROUTER_URL = (productID, variantID) => `/site/club-inventory/product-stock/detail/${productID}/${variantID}/`;

// 加盟店管理
export const CLUB_COMPANY_OVERVIEW_ROUTER = '/site/club-company/overview/';
export const CLUB_COMPANY_COMPANY_ROUTER  = '/site/club-company/company/';

// Dashboard
export const DASHBOARD_TAG_ROUTER = `/site/dashboard/tag/`;
export const DASHBOARD_MEMBER_PROFILE_ROUTER = `/site/dashboard/member-profile/`;

// 設備租賃
export const DEVICE_RENTAL_BATCH_PAYMENT_OVERVIEW_ROUTER    = '/site/device-rental/batch-payment/overview/';
export const DEVICE_RENTAL_BATCH_PAYMENT_BILLING_ROUTER     = `/site/device-rental/batch-payment/:maskID/`;
export const DEVICE_RENTAL_BATCH_PAYMENT_BILLING_ROUTER_URL = (maskID) => `/site/device-rental/batch-payment/${maskID}/`;

// 設備租賃 月產訂單
export const DEVICE_RENTAL_ORDERS_OVERVIEW_ROUTER = `/site/device-rental/orders/overview/`;


// 訂單
export const ORDERS_VIEW_ROUTER     = `/site/orders/:orderID/read-only`;
export const ORDERS_VIEW_ROUTER_URL = (orderID) => `/site/orders/${orderID}/read-only`;

// 財務作業
export const FINANCE_TRIPLICATE_INVOICE_ALLOWANCE_OVERVIEW_ROUTER = `/site/finance/triplicate-invoice-allowance/overview/`;

// 商品管理
export const PRODUCT_OVERVIEW_ROUTER   = `/site/product/overview/`;
export const PRODUCT_ADD_ROUTER    = `/site/product/add/`;
export const PRODUCT_DETAIL_ROUTER = `/site/product/detail/:productID/`;
export const PRODUCT_DETAIL_ROUTER_URL = (productID) => `/site/product/detail/${productID}/`;
export const PRODUCT_EDIT_ROUTER   = `/site/product/edit/:productID/`;
export const PRODUCT_EDIT_ROUTER_URL   = (productID) => `/site/product/edit/${productID}/`;
